// extracted by mini-css-extract-plugin
export default {"lheader":"header_lheader__zAmce","mya":"header_mya__n++U0"};